import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

/**
 * Query batch superbills
 */
export default async function queryBatchSuperbills() {
  const res = await fetchOrchidAPI("/api/scheduler/v1/batch_superbill/", {
    method: "POST",
  });
  if (!res.ok) {
    throw new Error(getErrorDetail(await res.text()));
  }

  return res.json();
}
